import React, { Fragment } from 'react';
import EnhancedModal from '../../../../../../../components/enhanced-modal';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Card, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_MD, SPAN_FULL, SPAN_HALF } from '../../../../../../../styles/constants';
import FileInput from "../../../../../../../components/file-input";
import { getImportCaseFunction, hideFileComponentFunctionWizard, onChangeFileFunction, onSubmitFunction, showfileServerPreview, submitFileMappingWizardFileComponent } from '../../actions';
import PreviewFileWizard from './PreviewFileWizard';
import _ from "lodash";


const mapStateToProps = state => ({
    addFileComponentFunctionWizardVisible:state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFileComponentFunctionWizardVisible,
    FileComponent:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FileComponent,
    fileServerPath:state.scenes.dataManager.fileMapping.components.wizard.components.addField.fileServerPath,
    functionType: state.scenes.dataManager.fileMapping.components.wizard.components.addField.functionType,
    mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
})
const mapDispatchToProps = dispatch => ({
    onChange: (fields) => dispatch(onChangeFileFunction(fields)),
    onHideFileComponentFunctionWizard: ()=> dispatch(hideFileComponentFunctionWizard()),
    onUploadFile: (file) => dispatch(submitFileMappingWizardFileComponent(file)),
    onShowPreviewFile: ()=> dispatch(showfileServerPreview()),
    onImportFile: (separator,delimiter, hasHeader,filePath,filedName) => dispatch(getImportCaseFunction(separator,delimiter, hasHeader,filePath,filedName)),
    onFunctionSubmit: (functionTypeName, functionTypeBase) => dispatch(onSubmitFunction(functionTypeName, functionTypeBase))
})

const mapPropsToFields = ({
    FileComponent
}) => ({
    componentValue: Form.createFormField({value: !!FileComponent.componentValue ?  FileComponent.componentValue : null }),
    separator: Form.createFormField({value:!!FileComponent.separator ? FileComponent.separator : null}),
    delimiter: Form.createFormField({value:!!FileComponent.delimiter ? FileComponent.delimiter : null }),
    hasHeader: Form.createFormField({value:!!FileComponent.hasHeader ? FileComponent.hasHeader : false}),
    file: Form.createFormField({value:!!FileComponent.file ? FileComponent.file : null})
})

const onFieldsChange = (props, fields) => props.onChange(fields);

const FileComponentWizard = ({
    t,
    form,
    addFileComponentFunctionWizardVisible,
    onHideFileComponentFunctionWizard,
    FileComponent,
    onUploadFile,
    fileServerPath,
    onShowPreviewFile,
    onImportFile,
    mergedHeader
}) => {

    const selectComponent = React.useMemo(()=>{
        return _.some(mergedHeader) ? mergedHeader.map(e => e.name) :  []
    },[mergedHeader])

    return (
        <Fragment>
            <EnhancedModal 
                width={MODAL_WIDTH_MD}
                title={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.title')}
                visible={addFileComponentFunctionWizardVisible}
                onCancel={onHideFileComponentFunctionWizard}
                footer={
                    <div>
                        <Button onClick={onHideFileComponentFunctionWizard}>{t('scenes.dataManager.fileMapping.wizard.addField.buttons.close')}</Button>
                        <Button type="primary" 
                            disabled={!FileComponent.separator || !fileServerPath}
                            onClick={()=>onImportFile(
                                FileComponent.separator && FileComponent.separator,
                                FileComponent.delimiter && FileComponent.delimiter,
                                FileComponent.hasHeader && FileComponent.hasHeader,
                                fileServerPath,
                                FileComponent.componentValue && FileComponent.componentValue
                                )}
                            >{t('scenes.dataManager.fileMapping.wizard.addField.buttons.confirm')}</Button>
                    </div>
                }
            >
                <Card>
                    <Form className="advanced-form">
                    <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
                        <Col span={SPAN_FULL}>
                            <Form.Item
                            className="form-item-required"  
                            label={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.label.selectComponent')}
                            >
                            {form.getFieldDecorator('componentValue')(
                                <Select
                                    title={form.getFieldValue('componentValue')}>
                                    {
                                        selectComponent.map((comp) => (
                                            <Select.Option
                                            title={comp}
                                            value={comp}
                                            key={comp}
                                            >
                                                {comp}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                            )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
                        <Col span={SPAN_HALF}>
                            <Form.Item className="form-item-required" 
                                label={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.label.separator')}>
                                {form.getFieldDecorator('separator')(<Input maxLength={1} />)}
                            </Form.Item>
                        </Col>
                        <Col span={SPAN_HALF}>
                            <Form.Item 
                                label={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.label.delimiter')}>
                                {form.getFieldDecorator('delimiter')(<Input  maxLength={1} />)}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
                        <Col span={SPAN_FULL}>
                            <Form.Item
                            className='form-item-required'
                            label={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.label.hasHeader')}
                            >
                                {form.getFieldDecorator('hasHeader',{valuePropName: 'checked'})(
                                    <Checkbox />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
                        <Col span={SPAN_FULL}>
                            <Form.Item 
                            className="form-item-required"
                            label={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.label.selectFile')}>
                                {form.getFieldDecorator('file')(
                                    <FileInput 
                                        accept={".csv"}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    </Form>
                    <Row>
                        <Col span={SPAN_HALF}>
                        <Row type='flex' align='middle' style={{gap:8}} >
                            <Button type="primary"  icon="upload" 
                            disabled={!FileComponent.file}
                            onClick={() => onUploadFile(FileComponent.file)}
                            >{t('scenes.dataManager.fileMapping.wizard.addField.buttons.upload')}</Button>
                            <Button icon="table"
                            disabled={!FileComponent.file || !fileServerPath}
                            onClick={onShowPreviewFile}
                            >{t('scenes.dataManager.fileMapping.wizard.addField.buttons.preview')}</Button>
                        </Row>
                        </Col>
                    </Row>
                </Card>
            </EnhancedModal>
            <PreviewFileWizard />
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps,mapDispatchToProps),
    Form.create({ mapPropsToFields, onFieldsChange })
)(FileComponentWizard)